<script setup>
import { onMounted, ref, watch } from 'vue';
import { useFelixBagAuxStore, useGlobalStateStore } from '../../../store';
import ListaTrilhaDeCuidados from './components/ListaTrilhaDeCuidados.vue';
import ModalLicencaAcabou from './components/ModalLicencaAcabou.vue';
import ModalEntrelacos from './components/ModalEntrelacos.vue'
import SeuMentor from './components/SeuMentor.vue'
import requestApi from '@/utils/requestApi'
import cargosEntrelacos from '@/utils/cargosEntrelacos.json'


const felixBagAuxStore = useFelixBagAuxStore();
const globalStateStore = useGlobalStateStore();

const showTrilhaDeCuidados = ref(false)

const showModalLicencaAcabou = ref(false)
const showModalEntrelacos = ref(false)
const showMentor = ref(false)
const loadingMentorStatus = ref(true)
const statusMentor = ref('')
const name = ref('')
const content = ref('')
const choosedMentor = ref(null)
const canSeeEntrelacos = ref(false)

const cargosEntrelacosInclude = ref(cargosEntrelacos.includes(window.ovmConfig.env['CARGO']))

onMounted(() => {
  felixBagAuxStore.pauseAfter(40200)
  checkName()
  showModalMentor()
  checkOnboarding()
  if (globalStateStore.globalState.selectedData.acceptedEntrelacos === true) {
    checkStatusMentor()
  }
});

function openTrilhaDeCuidados(contentBot) {
  content.value = contentBot
  showTrilhaDeCuidados.value = true
}

function openQuadroDeAvisos() {
  felixBagAuxStore.showInteractive("quadro-de-avisos")
}

function openTrilhaDeCuidadosFinais() {
  felixBagAuxStore.showInteractive("trilha-de-cuidado")
}

function checkName() {
  if (window.ovmConfig.env['NOME_SOCIAL']) {
    name.value = window.ovmConfig.env['NOME_SOCIAL'].split(" ")[0]
  } else if (window.ovmConfig.env['NOME_CADASTRADO']) {
    name.value = window.ovmConfig.env['NOME_CADASTRADO'].split(" ")[0]
  } else {
    name.value = window.ovmConfig.env['PRIMEIRO_NOME']
  }
}

function checkStatusMentor() {
  requestApi({
    url: `/v2/vivo_manager_mentor_mentoship/video/${process.env.VUE_APP_VIDEO_ID}/user/${window.ovmConfig.env['CPF']}/check_mentoring_status`,
    method: 'get',
    headers: {
      BCS: globalStateStore.uuid,
      'Content-Type': 'application/json',
    }
  }).then(response => {
    statusMentor.value = response.data.status
    if (statusMentor.value === "SELECIONAR") {
      statusMentor.value = "Faça sua escolha"
      console.log(choosedMentor.value)
    } else if (statusMentor.value === "AGUARDANDO") {
      statusMentor.value = "Aguardando"
    } else if (statusMentor.value === "FINALIZADO") {
      statusMentor.value = "Veja sua escolha"
      getSelectedMentor()
    }
    loadingMentorStatus.value = false
  })
}

function getSelectedMentor() {
  requestApi({
    url: `v2/mentors_mentee/mentee/${window.ovmConfig.env['CPF']}/video/${process.env.VUE_APP_VIDEO_ID}/get_mentor`,
    method: 'get',
    headers: {
      BCS: globalStateStore.uuid,
      'Content-Type': 'application/json',
    }
  }).then(response => {
    choosedMentor.value = response.data
    // choosedMentor.value = {biography: "Lore ipsum", created_at: "2024-05-10T17:20:57.425Z", email: "joao.segal@workverse.digital", name: "Joao Wk", number_of_mentees: 0, phone: "85999999999", photo: "https://overmediacast-videos-sp.s3-sa-east-1.amazonaws.com/65ef2558e34902000230c37c/405fdb6e-c8a5-41bd-b083-a0f168685e23.jpg", position: "Executivo", updated_at: "2024-05-23T20:45:22.625Z", _id: "663e5779210701003165210a"}
  }).catch((error) => {
    if (error.response.status === 404) {
      console.log(error)
    }
  })
}

function checkOnboarding() {
  let today = new Date();
  requestApi({
    url: `/v2/vivo_integration/video/${process.env.VUE_APP_VIDEO_ID}/user/${window.ovmConfig.env['CPF']}/get_data_termino_afastamento`,
    method: 'get',
    headers: {
      BCS: globalStateStore.uuid,
      'Content-Type': 'application/json',
    }
  }).then(response => {
    let targetDate = new Date(response.data['DATA_TERMINO_AFASTAMENTO']);
    targetDate.setUTCHours(targetDate.getUTCHours() + 3);
    if (today > targetDate) {
      if (globalStateStore.globalState.selectedData.returnDate === null) {
        showModalLicencaAcabou.value = true
      }
      globalStateStore.globalState.selectedData.returnDate = true
    }
  }).catch((error) => {
    if (error.response.status === 404) {
      // if(globalStateStore.globalState.selectedData.returnDate === null) {
      //   showModalLicencaAcabou.value = true
      // }
      // globalStateStore.globalState.selectedData.returnDate = true
      console.log(error)
    }
  })
}

function showModalMentor() {
  let listCpf = ['35013814847', '37579735857', '38803252860', '37333025837', '81738099091', '34005752837', '13117150706', '95918230530', '03735457118', '01640417028', '28785313882', '13567407740']
  if (listCpf.includes(window.ovmConfig.env['CPF'])) {
    canSeeEntrelacos.value = true
    return
  } else if (globalStateStore.globalState.selectedData.acceptedEntrelacos === true) {
    canSeeEntrelacos.value = true
  } else if (globalStateStore.globalState.selectedData.acceptedEntrelacos === null && cargosEntrelacosInclude.value) {
    showModalEntrelacos.value = true
  }
}

function finalizarAcolhimento() {
  felixBagAuxStore.seekTo(felixBagAuxStore.scenes.avaliacao_final_cuidados)
}

watch(() => globalStateStore.globalState.selectedData.acceptedEntrelacos, (newValue) => {
  if (newValue === true) {
    canSeeEntrelacos.value = true
  }
})
</script>

<template>
  <div id="trilha-de-cuidados-final">
    <v-row align-content="center" justify="space-evenly"
      style="margin-top: 22%;margin-bottom: 0%; padding: 0 3% 0 7.5%;" class="top-area">
      <v-avatar style="border: 1px solid #FF9900;" color="white">
        <img :src="globalStateStore.globalState.selectedData.profile.img" style="width: 100%;" alt="">
      </v-avatar>
      <div style="text-align: start; width: 46%;">
        <p style="color: #464646; font-size: 11px;">Aproveite sua jornada.</p>
        <p style="font-size: 18px; margin-right: 20px;">{{ name }}</p>
      </div>

      <div style="width: 40px; height: 40px;">
        <button
          style="background-color:rgb(102, 0, 153); width: 100%; height: 100%; border-radius: 8px; align-items: center; display: flex; justify-content: center;"
          @click="felixBagAuxStore.showInteractive('dicas-de-uso')">
          <img style="width: 65%;"
            src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/d520f86a-9e4e-4455-bc4b-195600a42048.svg"
            alt="">
        </button>
      </div>
    </v-row>

    <div style="height: 54%; overflow: auto;">
      <div class="menu-item" @click="openQuadroDeAvisos">
        <v-row>
          <v-col cols="6">
            <img
              src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/f15c3c1c-8ec1-4dcc-9a71-6f80444797dc.svg"
              alt="">
          </v-col>

          <v-col cols="6" class="item-text">
            <p class="item-title">Seu quadro de avisos</p>
          </v-col>
        </v-row>
      </div>

      <div v-if="globalStateStore.globalState.selectedData.returnDate" class="menu-item"
        @click="openTrilhaDeCuidados('reonboarding')">
        <v-row>
          <v-col cols="6">
            <img
              src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/77de9681-0361-43a0-8f19-a25241fef387.png"
              alt="">
          </v-col>

          <v-col cols="6" class="item-text">
            <v-chip style="background: #81D300; color: white; font-size: 10px;" density="compact">{{
              globalStateStore.calcularPorcentagemReonboarding() }}% completo</v-chip>
            <p class="item-title">Seu Onboarding</p>
          </v-col>
        </v-row>
      </div>

      <div :class="{ 'overlay-disabled': statusMentor === 'Aguardando' }"
        v-if="globalStateStore.globalState.selectedData.acceptedEntrelacos && canSeeEntrelacos" class="menu-item"
        @click="statusMentor === 'Aguardando' ? '' : showMentor = true">
        <v-row>
          <v-col cols="6">
            <img
              src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/339ebd0c-ec87-4c3f-a10b-62d993620c36.svg"
              alt="">
          </v-col>

          <v-col cols="6" class="item-text">
            <v-chip :style="{ backgroundColor: statusMentor === 'Aguardando' ? '#f9d16b' : '#81D300' }"
              v-if="!loadingMentorStatus" style="color: white; font-size: 10px;" density="compact">{{ statusMentor
              }}</v-chip>
            <p class="item-title">Quem te acolhe</p>
          </v-col>
        </v-row>
      </div>

      <div class="menu-item" @click="openTrilhaDeCuidados('cuidados_com_o_bebe')">
        <v-row>
          <v-col cols="6">
            <img
              src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/2aa3c854-a4b0-4e1c-beaf-b8f01167d33b.svg"
              alt="">
          </v-col>

          <v-col cols="6" class="item-text">
            <v-chip style="background: #81D300; color: white; font-size: 10px;" density="compact">{{
              globalStateStore.calcularPorcentagemFamiliar() }}% completo</v-chip>
            <p class="item-title">Cuidados com seu novo familiar</p>
          </v-col>
        </v-row>
      </div>

      <div class="menu-item" @click="openTrilhaDeCuidadosFinais()">
        <v-row>
          <v-col cols="6">
            <img
              src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/5641715a-3520-4a02-987b-8bd04b8f99c1.svg"
              alt="">
          </v-col>

          <v-col cols="6" class="item-text">
            <v-chip style="background: #81D300; color: white; font-size: 10px;" density="compact">{{
              globalStateStore.calcularPorcentagemVoce() }}% completo</v-chip>
            <p class="item-title">Cuidados com Você</p>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-btn v-if="!globalStateStore.globalState.selectedData.doneAvaliacao" @click="finalizarAcolhimento"
      style="width: 80%; position: absolute; bottom: 13.5%; left: 10%" class="text-none" color="#660099">Finalizar
      jornada Vivo +Família</v-btn>
  </div>

  <ListaTrilhaDeCuidados @close-list="showTrilhaDeCuidados = false" v-if="showTrilhaDeCuidados" :content="content" />
  <ModalLicencaAcabou @modal-entrelacos="showModalMentor()" @close-modal="showModalLicencaAcabou = false"
    v-if="showModalLicencaAcabou" />
  <ModalEntrelacos @close-modal="showModalEntrelacos = false"
    @close-modal-accepting="showModalEntrelacos = false, checkStatusMentor()" v-if="showModalEntrelacos">
  </ModalEntrelacos>
  <SeuMentor :choosedMentor="choosedMentor" @close-mentor="showMentor = false, checkStatusMentor()" v-if="showMentor">
  </SeuMentor>
</template>

<style scoped>
#trilha-de-cuidados-final {
  width: 100%;
  height: 100%;
}

.top-area {
  margin-top: 10%;
}

.menu-item {
  background-color: #fff;
  width: 85%;
  height: 46%;
  border-radius: 8px;
  margin: 10% 7.5% 11%;
  cursor: pointer;
}

.menu-item img {
  width: 85%;
  margin: 10px 20px;
}

.item-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: flex-start;
}

.item-title {
  margin-top: 7px;
  width: 70%;
  text-align: left;
  font-size: 14px;
}

.overlay-disabled {
  background: rgba(255, 255, 255, 0.6);
  cursor: not-allowed;
}
</style>
